import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { Cabecalho } from '@app/core/cabecalho/cabecalho';
import { CabecalhoService } from '@app/core/cabecalho/cabecalho.service';
import { LoginService } from '@app/core/openid/login.service';
import { ModalConfirmacaoSair } from '@app/shared/modal-confirmacao-sair';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
})
export class MainComponent {
  @Input() public version: string;

  public cabecalho: Observable<Cabecalho>;

  constructor(
    cabecalhoService: CabecalhoService,
    private loginService: LoginService,
    private modalService: NgbModal
  ) {
    this.cabecalho = cabecalhoService.getCabecalho();
  }

  public openModalConfirmacao() {
    ModalConfirmacaoSair.openModal(this.modalService, this.loginService);
  }
}
